<template>
  <div>
    <ProjectCardList
      :projects="$store.state.ProjectStore.projects"
    ></ProjectCardList>
  </div>
</template>

<script>
//import ProjectModel from '../models/ProjectModel'
import ProjectCardList from '../components/ProjectCardList'
import { licensingEngineApi } from 'licensing-engine-sdk'

export default {
  components: {
    ProjectCardList
  },
  data() {
    return {
      name: 'Dummy Project Name',
      licenses: []
    }
  },
  created: function() {
    this.$store.dispatch('ProjectStore/fetchProjects')
    this.$store.dispatch('OrganizationStore/fetchOrganizationsForUsers')
  },
  async mounted() {
    const qwe = await licensingEngineApi('domain').getLicenses[''].GET()
    this.licenses = qwe
  },
  methods: {}
}
</script>

<style scoped></style>
